import { Link } from "react-router-dom";
import Breadcrumbs from "@/components/base/Breadcrumbs";

interface Props {
  categoryName: string;
  description: string;
  count: number;
}

export default function CategoryHeader({ categoryName, description, count }: Props) {
  return (
    <div className="w-full px-4 md:px-6 pt-6 md:pt-8">
      <Breadcrumbs
        items={[
          { label: "首页", to: "/" },
          { label: "分类", to: "/category/hot-blood" },
          { label: categoryName },
        ]}
      />
      <div className="mt-4 flex flex-col md:flex-row md:items-end justify-between gap-3">
        <div className="min-w-0">
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            {categoryName}漫画 · 禁漫天堂
          </h1>
          <p className="mt-2 text-xs md:text-sm leading-6 text-foreground-400 max-w-[720px]">{description}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className="h-8 px-3 rounded-md border hairline bg-background-900/70 text-xs text-foreground-300 flex items-center gap-1.5">
            <i className="ri-stack-line text-accent-400" />
            共 {count} 部
          </span>
          <Link
            to="/search"
            className="h-8 px-3 rounded-md bg-primary-500 text-background-50 text-xs flex items-center gap-1.5 hover:bg-primary-400 transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line" />
            搜索其他作品
          </Link>
        </div>
      </div>
    </div>
  );
}